export default "__VITE_ASSET__mfgIBQlm__"